import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {BrickSnake2000} from "../../../BrickSnake2000";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";


/**
 * Created by jonas on 2022-01-12.
 */

export class BrokeBankPresentation implements SimplePresentation {

    name:string = "BrokeBankPresentation";

    constructor() {
    }



    shouldRun():boolean {
        return BrickSnake2000.model.gameData.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        // TODO clean up once the proper max win animation is ready
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BrickSnake2000.keypadPlugin.setZeroBetSpinCounter(-1);
            BrickSnake2000.soundPlayer.fadeOutMusic();
            BrickSnake2000.soundPlayer.playLoopingSound("winCapLoop");
            BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.gameData.accumulatedRoundWin,
                                               BrickSnake2000.model.data.mode != GameMode.NORMAL,
                                               BrickSnake2000.isWinBelowStake());
        })
        tl.add(BrickSnake2000.transitionScreen.showMaxWin());
        if (SlotGame.apiPlugin.gameClientConfiguration.gambleFiftyFiftyAllowed) {
            tl.add(() => controller.finish(), '>2');
        } else {
            tl.add(BrickSnake2000.transitionScreen.enableButton(() => this.onButtonClick(controller)), '>5');
        }
     }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            BrickSnake2000.soundPlayer.switchMusic(GameMode.NORMAL)
            BrickSnake2000.keypadPlugin.setWin(BrickSnake2000.model.data.accumulatedRoundWin,
                                           BrickSnake2000.model.data.mode != GameMode.NORMAL,
                                           BrickSnake2000.isWinBelowStake());
            BrickSnake2000.freespinsReelView.disable();
            BrickSnake2000.baseGameReelView.enable();
            BrickSnake2000.baseGameReelView.getAllSymbolsActually().forEach((sym) => sym.alpha = 1);
        })
        tl.add(BrickSnake2000.backgroundElements.setToBaseGame());

        // if we got max win in freespins
        if (BrickSnake2000.model.data.mode == GameMode.FREESPIN) {
            tl.add(BrickSnake2000.transitionScreen.hideOutro(), '<');
        } else if (BrickSnake2000.model.data.mode == GameMode.FREESPIN_SUPER) {
            tl.add(BrickSnake2000.transitionScreen.hideOutroSuper(), '<');
        }

        tl.add(() => {
            BrickSnake2000.soundPlayer.fadeInMusic();
            BrickSnake2000.soundPlayer.stopSound("winCapLoop");
            //BrickSnake2000.popUpView.showPopUp();
        })
        tl.add(BrickSnake2000.transitionScreen.hideMaxWin());
        tl.add(() => controller.finish());

    }
}